<template>
  <v-layout no-gutters 
    class="cirrus-browser-body oct-browser-body escalon-absolute-cover"
    :style="ieStyle">
    <v-flex shrink class="sidebar-controls secondary" :style="borderStyle">
      <cirrus-sidebar-controls />
    </v-flex>
    <cirrus-optic-disc-body-content
      v-if="this.isOpticDisc" />
    <cirrus-browser-body-content
      v-else />
  </v-layout>
</template>

<script>
import cirrusSidebarControls from "./CirrusSidebarControls";
import cirrusBrowserBodyContent from "./CirrusBrowserBodyContent";
import cirrusOpticDiscBodyContent from "./CirrusOpticDiscBodyContent";
import { mapGetters } from "vuex";
import { SeriesTypes } from "../../../config/config";
export default {
  name: "cirrusBrowserBody",
  components: {cirrusSidebarControls, cirrusBrowserBodyContent, cirrusOpticDiscBodyContent },
  computed: {
    ...mapGetters([
      "seriesType",
      "isIE"]),

    ieStyle() {
      if (!this.isIE) return null;
      return "margin-top: 35px";
    },
    isOpticDisc() {
      return this.seriesType == SeriesTypes.OpticDisc;
    }
  }
};
</script>
